import { SinglePathSVG } from "components/views/SVG"
import React, { FC, ReactElement } from "react"
import styled from "styled-components"
import Breadcrumb from "./Breadcrumb"
import { Header } from "./Header"
import { Large, Medium, Small } from "./Responsive"

const Chevron = styled(SinglePathSVG).attrs({ className: "black-60" })`
  margin: 0px 11px;
`

const CrumbsContainer = styled.div.attrs({ className: "flex items-center" })``

const seperator = <Chevron icon="rightCarrotSmall" />

type BreadcrumbsHeaderProps = {
  breadcrumbs: ReactElement<typeof Breadcrumb>[]
}

const AllCrumbs = ({ breadcrumbs }: BreadcrumbsHeaderProps) => {
  return breadcrumbs.reduce((display, crumb) => (
    <>
      {display}
      {seperator}
      {crumb}
    </>
  ))
}

const CollapsedCrumbs = ({ breadcrumbs }: BreadcrumbsHeaderProps) => {
  const [first] = breadcrumbs
  const last = breadcrumbs[breadcrumbs.length - 1]
  return (
    <>
      {first}
      {seperator}
      ...
      {seperator}
      {last}
    </>
  )
}

const BreadcrumbsHeader: FC<BreadcrumbsHeaderProps> = ({ breadcrumbs }) => {
  return (
    <Header>
      <Large>
        <CrumbsContainer>
          <AllCrumbs breadcrumbs={breadcrumbs} />
        </CrumbsContainer>
      </Large>
      <Medium>
        <CrumbsContainer>
          {breadcrumbs.length > 3 ? (
            <CollapsedCrumbs breadcrumbs={breadcrumbs} />
          ) : (
            <AllCrumbs breadcrumbs={breadcrumbs} />
          )}
        </CrumbsContainer>
      </Medium>
      <Small>
        <CrumbsContainer>
          {breadcrumbs.length > 2 ? (
            <CollapsedCrumbs breadcrumbs={breadcrumbs} />
          ) : (
            <AllCrumbs breadcrumbs={breadcrumbs} />
          )}
        </CrumbsContainer>
      </Small>
    </Header>
  )
}

export default BreadcrumbsHeader
